export default "__VITE_ASSET__71024ac5__"